import { cn } from '@/utils/classname';

export interface PraetorianBadgeProps {
  /** Label text (default: "Praetorian Only") */
  label?: string;
  /** Size variant */
  size?: 'sm' | 'md' | 'lg';
  /** Additional CSS classes */
  className?: string;
}

/**
 * PraetorianBadge - Displays the Praetorian logo with label text
 *
 * Used to indicate features or content restricted to Praetorian users.
 *
 * @example
 * ```tsx
 * <PraetorianBadge />
 * <PraetorianBadge label="Praetorian Users Only" size="lg" />
 * ```
 */
export function PraetorianBadge({
  label = 'Praetorian Only',
  size = 'md',
  className,
}: PraetorianBadgeProps) {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <img
        src="/icons/logo.png"
        alt="Praetorian"
        className={cn(
          size === 'sm' && 'size-3',
          size === 'md' && 'size-5',
          size === 'lg' && 'size-6'
        )}
      />
      <span className="font-semibold">{label}</span>
    </div>
  );
}
